export default "__VITE_ASSET__JRrHUFP3__"